import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-global-loader',
  templateUrl: './global-loader.component.html',
  styleUrls: ['./global-loader.component.css']
})
export class GlobalLoaderComponent {

}
